<template>
  <v-card outlined>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" class="pa-1">
          <v-card>
            <v-responsive :aspect-ratio="2560/360">
              <v-img :src="settings.header">
                <v-card-title>
                  Header
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-subtitle>Ideal: 2560px x 360px</v-card-subtitle>
              </v-img>
            </v-responsive>            
          </v-card>
        </v-col>
        <v-col cols="2" class="pa-1">
          <v-card>
            <v-responsive :aspect-ratio="1/1">
              <v-img :src="settings.logo">
                <v-card-title>Logo</v-card-title>
                <v-card-subtitle>Ideal: 500px x 500px</v-card-subtitle>
              </v-img>
            </v-responsive>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-row class="pa-2 pt-4">
            <v-card-title>Webadressen</v-card-title>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined placeholder="Mitglied" label="Bezeichnung Mitglied (Einzahl)" v-model="settings.bezMitglieder1"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined placeholder="Mitglieder" label="Bezeichnung Mitglieder" v-model="settings.bezMitglieder"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined placeholder="Vorstand" label="Bezeichnung Vorstand (Einzahl)" v-model="settings.bezVorstand1"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined placeholder="Vorstand" label="Bezeichnung Vorstand" v-model="settings.bezVorstand"></v-text-field></v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="pa-1">
          <v-card :style="'background-color:' + settings.primary" outlined class="justify-center pa-1 pl-2">
            <v-card-title>Primärfarbe</v-card-title>
            <v-color-picker
              v-model="settings.primary"
            ></v-color-picker>
          </v-card>
        </v-col>
        <v-col cols="3" class="pa-1">
          <v-card :style="'background-color:' + settings.secondary" outlined class="justify-center pa-1 pl-2">
            <v-card-title>Sekundärfarbe</v-card-title>
            <v-color-picker
              v-model="settings.secondary"
            ></v-color-picker>
          </v-card>
        </v-col>
        <v-col cols="3" class="pa-1">
          <v-card :style="'background-color:' + settings.tertiary" outlined class="justify-center pa-1 pl-2">
            <v-card-title>Tertiärfarbe</v-card-title>
            <v-color-picker
              v-model="settings.tertiary"
            ></v-color-picker>
          </v-card>
        </v-col>
        <v-col cols="3" class="pa-1">
          <v-card-title>Neue Bilder hochladen</v-card-title>
          <v-card-subtitle>Lade die Bilder idealerweise als .webp-Datei hoch.</v-card-subtitle>
          <v-file-input :loading="loading.logo" outlined dense v-model="selectPicture.logo" label="Logo (500px x 500px)" @change="uploadLogo()"></v-file-input>
          <v-file-input :loading="loading.header" outlined dense v-model="selectPicture.header" label="Header (1920px x 300px)" @change="uploadHeader()"></v-file-input>
          <v-file-input :loading="loading.background" outlined dense v-model="selectPicture.background" label="Login-Background-Bild (1920px x 1080px)" @change="uploadBackground()"></v-file-input>
        </v-col>
        <v-col cols="4" class="pa-1">
          <v-card>
            <v-responsive :aspect-ratio="1920/1080">
              <v-img :src="settings.background">
                <v-card-title>Background</v-card-title>
                <v-card-subtitle>Ideal: 1920px x 1080px</v-card-subtitle>
              </v-img>
            </v-responsive>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card-title>Hauptmenü Einträge</v-card-title>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuVeranstaltungen" label="Veranstaltungen"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuKontakte" label="Kontakte"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuRechnungen" label="Rechnungen"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuKontaktdaten" label="Kontaktdaten"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuDownload" label="Download"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuSemester" label="Semester"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showMenuStammbaum" label="Stammbaum"></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-card-title>Startseite Widgets</v-card-title>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetVeranstaltungen" label="Veranstaltungen"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetSuche" label="Suche"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetUpdates" label="Updates"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetGeburtstagsliste" label="Geburtstagsliste"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetMitglieder" label="Anzahl Mitglieder"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetChargen1" label="Chargen Aktivitas"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetChargen2" label="Chargen AHV"></v-checkbox>
          <v-checkbox class="py-0 my-0" dense v-model="settings.showWidgetChargen3" label="Chargen HBV"></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="save()">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      selectPicture: {},
      loading: {
        header: false,
        logo: false
      }
    }
  },
  computed: {
    settings () {
      return this.$store.getters['einstellungen/einstellung']('allgemein')
    }
  },
  methods: {
    uploadLogo () {
      this.loading.logo = true
      this.settings.logo = null
      const storageRef = this.$firebase.storage().ref(`/design/logo/${this.$vars.verbindung}`).put(this.selectPicture.logo)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { this.uploadStatus.error = error.message },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.settings.logo = url
          this.loading.logo = false
        })
      })
    },
    uploadHeader () {
      this.loading.header = true
      this.settings.header = null
      const storageRef = this.$firebase.storage().ref(`/design/header/${this.$vars.verbindung}`).put(this.selectPicture.header)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { this.uploadStatus.error = error.message },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.settings.header = url
          this.loading.header = false
        })
      })
    },
    uploadBackground () {
      this.loading.background = true
      this.settings.background = null
      const storageRef = this.$firebase.storage().ref(`/design/background/${this.$vars.verbindung}`).put(this.selectPicture.background)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { this.uploadStatus.error = error.message },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.settings.background = url
          this.loading.background = false
        })
      })
    },
    save () {
      this.$store.dispatch('einstellungen/updateEinstellungData', this.settings)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Design.vue?1860ab1e